import { render, staticRenderFns } from "./addParameter.vue?vue&type=template&id=5846d741&scoped=true&"
import script from "./addParameter.vue?vue&type=script&lang=js&"
export * from "./addParameter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5846d741",
  null
  
)

export default component.exports